import React from "react";

//Campo selector
//El indice de fila y columna se ocupa para identificar la celda en la que se ubica el selector, ocupado eventualmente por
//la función markAnswer() del proveedor de encuestas.

const SelectField = ({ name, defaultValueFromAnswer, handleChange, options }) => (
  <select
    className="custom-select"
    name={name}
    value={defaultValueFromAnswer}
    onChange={handleChange}
  >
    <option value="">-</option>
    {options.map((option, optionIndex) => (
      <option key={`${name}_option-${optionIndex}`} value={option}>
        {option}
      </option>
    ))}
  </select>
);

export default SelectField;
